module.exports = __webpack_public_path__ + "static/media/36-11.e44c2e79.mp3";